import Immutable from 'immutable';
import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = Immutable.fromJS({
  locationBeforeTransitions: null
});

export default (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    return state.set('locationBeforeTransitions', Immutable.fromJS(action.payload));
  }

  return state;
};



// WEBPACK FOOTER //
// src/core/immutableRouter.js